import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const ImageThumbnailContainer = styled('div')(({ theme }) => ({
  aspectRatio: '95/132',
  height: '100%',
  width: '100%',
  position: 'relative',
  cursor: 'pointer',
}));

export const ImageThumbnail = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: 8,
  objectFit: 'cover',
  backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.LIGHT_BORDER,
  pointerEvents: 'none',
}));
